import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_wraps.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("wrappers_wraps.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("wrappers_wraps.dimensions"),
        name: data?.dimensions,
      },
      {
        label: t("wrappers_wraps.show_in_packaging"),
        name:
          data?.show_in_packaging === true
            ? t("common.yes")
            : data?.show_in_packaging === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_wraps.is_active"),
        name:
          data?.is_active === true
            ? t("common.yes")
            : data?.is_active === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_wraps.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
